var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMastercard = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 46 28"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M39.227 1.167a4.667 4.667 0 0 1 4.666 4.666v16.334a4.667 4.667 0 0 1-4.666 4.666H6.56a4.666 4.666 0 0 1-4.667-4.666V5.833A4.667 4.667 0 0 1 6.56 1.167zm0-1.167H6.56A5.833 5.833 0 0 0 .727 5.833v16.334A5.833 5.833 0 0 0 6.56 28h32.667a5.833 5.833 0 0 0 5.833-5.833V5.833A5.833 5.833 0 0 0 39.227 0M21.855 9.427a5.542 5.542 0 1 0 0 9.146 6.92 6.92 0 0 1 0-9.146M32.59 14a5.542 5.542 0 1 1-11.083 0 5.542 5.542 0 0 1 11.083 0",
  clipRule: "evenodd"
})));
export default SvgMastercard;